import { createSlice } from "@reduxjs/toolkit";

const homeSlice = createSlice({
	name: "QFLO",
	initialState: {
		originalDevices: [],
		devices: [],
		deviceNotifications: [
			{
				name: "Welcome!",
				desc: "Thank you for using QFlo :)",
				filterDate: 0,
				date: "vhjsf8",
				type: "yessir !",
			},
		],
		alarmNotifications: [
			{
				name: "Welcome!",
				desc: "Thank you for using QFlo :)",
				filterDate: 1,
				date: "skjskl",
				type: "Yes sir!",
			},
		],
		focussedDevice: "",
		notificationFilter: "",
		deviceModalState: {},
		deviceModalVisibility: false,
		view: 1,
		viewLabel: false,
		optimizeView: 1,
		optimizeViewLabel: true,
	},
	reducers: {
		setOriginalDevices: (state, action) => {
			state.originalDevices = action.payload;
		},
		setDevices: (state, action) => {
			state.devices = action.payload;
		},
		filterDevices: (state, action) => {
			const payload = JSON.parse(action.payload);

			const handleDeviceStatus = (type: any) => {
				if (type === "powerOn") {
					state.devices = state.originalDevices.filter(
						(device) => device[`${payload.type}`] === payload.value
					);
				} else {
					state.devices = state.originalDevices.filter(
						(device: any) =>
							device[`${payload.type}`] === payload.value &&
							device.powerOn !== 0
					);
				}
			};

			switch (payload.type) {
				case "hot":
					state.devices = state.originalDevices.filter(
						(device: any) =>
							device.tempVal >
							device.tempSet + device.tempDiff + device.tempDiff
					);
					return;
				case "cold":
					state.devices = state.originalDevices.filter(
						(device: any) =>
							device.tempVal <
							device.tempSet - device.tempDiff - device.tempDiff
					);
					return;
				case "range":
					state.devices = state.originalDevices.filter(
						(device: any) =>
							device.tempVal <
								device.tempSet - device.tempDiff - device.tempDiff ||
							device.tempVal >
								device.tempSet + device.tempDiff + device.tempDiff
					);
					return;
				case "coolerOn":
					handleDeviceStatus(payload.type);
					return;
				case "heaterOn":
					handleDeviceStatus(payload.type);
					return;
				case "powerOn":
					handleDeviceStatus(payload.type);
					return;
				case "client":
					state.devices = state.originalDevices.filter(
						(device: any) => device.client === payload.value
					);
					return;
				case "site":
					state.devices = state.originalDevices.filter(
						(device: any) => device.site === payload.value
					);
					return;
				case "building":
					state.devices = state.originalDevices.filter(
						(device: any) => device.building === payload.value
					);
					return;
				case "area":
					state.devices = state.originalDevices.filter(
						(device: any) => device.area === payload.value
					);
					return;
			}
		},
		resetDevices: (state) => {
			state.devices = state.originalDevices;
		},
		setNotifications: (state: any, action) => {
			const searchObject = action.payload;
			const exists = state.deviceNotifications.some(
				(item: { type: any; name: any; desc: any; date: any }) =>
					item.type === searchObject.type &&
					item.name === searchObject.name &&
					item.date === searchObject.date &&
					item.desc === searchObject.desc
			);

			if (!exists && state.deviceNotifications.length < 51) {
				//filter array based off .deviceId
				//sort array by date .date
				//filteredArray.sort((a, b) => (b.filterDate) - (a.filterDate));
				//get latest value
				//const latestValue = filteredArray[0];
				//compare latest value with second latest value
				//const secondLatestValue = filteredArray[1];
				//=> secondLatestValue - latestValue
				//use condition to set message and increase or decrease
				//push final output to array
				//console.log(action.payload);
				state.deviceNotifications.push(action.payload);
			} else if (!exists && state.deviceNotifications.length >= 50) {
				//console.log(action.payload);
				const selectedDeviceArray = state.deviceNotifications.filter(
					(item: any) => item.deviceId === searchObject.deviceId
				);
				state.deviceNotifications.shift();
				state.deviceNotifications.push(action.payload);
			}
		},
		setAlarmNotifications: (state: any, action) => {
			const searchObject = action.payload;
			const exists = state.alarmNotifications.some(
				(item: { type: any; name: any; desc: any; date: any }) =>
					item.type === searchObject.type &&
					item.name === searchObject.name &&
					item.date === searchObject.date &&
					item.desc === searchObject.desc
			);
			if (!exists && state.alarmNotifications.length < 51) {
				state.alarmNotifications.push(action.payload);
			} else if (!exists && state.alarmNotifications.length >= 50) {
				state.alarmNotifications.shift();
				state.alarmNotifications.push(action.payload);
			}
		},
		setFocussedDevice: (state, action) => {
			state.focussedDevice = action.payload;
		},
		setNotificationFilter: (state, action) => {
			state.notificationFilter = action.payload;
		},
		setDeviceModalState: (state, action) => {
			state.deviceModalState = action.payload;
		},
		setDeviceModalVisibility: (state, action) => {
			state.deviceModalVisibility = action.payload;
		},
		setView: (state) => {
			if (state.view === 1) {
				state.viewLabel = true;
				state.view = 2;
			} else {
				state.viewLabel = false;
				state.view = 1;
			}
		},
		setOptimizeView: (state) => {
			if (state.optimizeView === 1) {
				state.optimizeViewLabel = false;
				state.optimizeView = 2;
			} else {
				state.optimizeViewLabel = true;
				state.optimizeView = 1;
			}
		},
	},
});

export const {
	setOriginalDevices,
	setDevices,
	filterDevices,
	resetDevices,
	setNotifications,
	setAlarmNotifications,
	setFocussedDevice,
	setNotificationFilter,
	setDeviceModalState,
	setDeviceModalVisibility,
	setView,
	setOptimizeView,
} = homeSlice.actions;
export default homeSlice.reducer;
